import { CalculationResult } from '../calculation/CalculationResult.types';
import { CustomMessageEvent } from './websocket.worker';

export enum WEBSOCKET_ACTIONS {
    INITIALIZE = 'INITIALIZE',
    CALCRESULTS_RECEIVED = 'CALCRESULTS_RECEIVED',
    CALCULATION_PROGRESS = 'CALCULATION_PROGRESS',
    CALCULATION_FAILED = 'CALCULATION_FAILED',
    PRINT_RESULT = 'PRINT_RESULT',
    PRINT_FAILED = 'PRINT_FAILED',
    AHU_CREATED = 'AHU_CREATED',
    DISCONNECT = 'DISCONNECT'
}

export type WebsocketWorkerType = {
    onmessage: (e: MessageEvent) => void;
    onerror: (e: MessageEvent) => void;
    addEventListener: (
        message: string,
        listener: (
            event:
                | MessageEvent<unknown>
                | CustomMessageEvent
                | WebsocketWorkerMessageEvent
        ) => void
    ) => void;
    removeEventListener: (
        message: string,
        listener: (e: MessageEvent) => void,
        type?: WEBSOCKET_ACTIONS
    ) => void;
    postMessage: (message: CustomMessageEvent) => void;
};

export interface WebsocketWorkerMessageEvent extends MessageEvent {
    data: {
        message:
            | PrintResultMessage
            | PrintFailedMessage
            | CalculationProgressMessage
            | CalculationFailedMessage
            | CalculationReceivedMessage;
        task: WEBSOCKET_ACTIONS;
    };
}

interface BaseWebsocketMessage {
    CreationDate: string;
    JobId: string;
}

export interface PrintResultMessage extends BaseWebsocketMessage {}

export interface PrintFailedMessage extends BaseWebsocketMessage {}
interface BaseCalculationMessage {
    CreationDate: string;
    Id: string;
    JobId: string;
    AhuSequenceNumber?: number;
}
type ProgressStep = {
    index: number;
    message: string;
};
export interface AhuCreatedMessage extends BaseWebsocketMessage {
    Id: string;
    AhuId: string;
}
export interface CalculationProgressMessage {
    creationDate: string;
    id: string;
    jobId: string;
    step: ProgressStep;
    lastStep: number;
}

export interface CalculationReceivedMessage extends BaseCalculationMessage {
    ahuId: string;
    calculationResult: CalculationResult;
    OperatingSetupId: string;
    jobId: string;
}

export interface CalculationFailedMessage {
    code: number;
    creationDate: string;
    id: string;
    jobId: string;
    message: string;
    origin?: string;
    textId?: string;
}
